import { NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID } from "@marble/core/modules/schools/suppressed-comms/constants";

export { NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID };

export function isPediatricianSchool(schoolId?: number | null): boolean {
  if (!schoolId) return false;
  return schoolId === NYC_HEALTH_AND_HOSPITALS_SCHOOL_ID;
}
